// Decision 3 (14/10, FE5): the exec's page for each follow-up email, opened from the reminder the day before it goes
// (?step=N&action=edit|pause|stop[&days=1|2|3]). Edit the text, Pause 1/2/3 days or Stop; doing nothing lets it go.
// A link only picks the panel: nothing changes until the user confirms on the page (mail scanners open links).

export const ACTIONS = ['edit', 'pause', 'stop']

export const PAUSE_DAYS = [1, 2, 3]

/** The ?action= of the reminder's link, or null (no panel open). */
export function startAction(query) {
  var a = String((query && query.action) || '').toLowerCase()
  return ACTIONS.indexOf(a) > -1 ? a : null
}

/** The ?days= of a pause link, when it is 1, 2 or 3. */
export function startDays(query) {
  var d = Number(query && query.days)
  return PAUSE_DAYS.indexOf(d) > -1 ? d : null
}

/** The ?step= of the link: which email the reminder was about. */
export function linkStep(query) {
  var s = Number(query && query.step)
  return s > 0 ? s : null
}

export function daysLabel(n) {
  return n + (n === 1 ? ' day' : ' days')
}

/** The body POSTed for the chosen change; { problem } when something is missing. */
export function answerBody(action, form, stepNo) {
  var f = form || {}
  if (action === 'edit') {
    var subject = (f.subject || '').trim()
    var text = (f.body || '').trim()
    if (!subject || !text) return { problem: 'The subject and the message are both needed.' }
    return { body: { action: 'EDIT', stepNo: stepNo, subject: subject, body: text } }
  }
  if (action === 'pause') {
    if (PAUSE_DAYS.indexOf(f.days) < 0) return { problem: 'Choose 1, 2 or 3 days.' }
    return { body: { action: 'PAUSE', stepNo: stepNo, days: f.days } }
  }
  if (action === 'stop') return { body: { action: 'STOP', stepNo: stepNo } }
  return { problem: 'Choose Edit the text, Pause or Stop.' }
}

/** What happened, in one line, from the server's answer (its dueAt is the email's new date). */
export function doneMessage(action, body, answer) {
  var due = answer && answer.dueAt
  if (action === 'edit') return 'Saved: your text goes for this quote' + (due ? ' on ' + due : '') + '.'
  if (action === 'pause') return 'Paused for ' + daysLabel(body.days) + (due ? ': the email now goes on ' + due : '') + '.'
  return 'Stopped: no more follow-up emails go for this quote.'
}

/**
 * The line above the email: what happens if the exec does nothing, or why nothing can be changed. `step` is the
 * link's step: the GET always answers about the next email to go, so an older link's email has already gone.
 */
export function statusLine(data, step) {
  if (!data) return ''
  if (data.stopped) return 'Follow-up emails for this quote are stopped' + (data.stopReason ? ' (' + data.stopReason.toLowerCase() + ')' : '') + '.'
  var older = step && data.stepNo && step < data.stepNo
  var lead = older ? 'The email this link was about has already gone. This is the next one. ' : ''
  if (data.sentAt) return lead + 'This email went on ' + data.sentAt + '.'
  if (!data.canChange) return lead + 'You cannot change this email.'
  return lead + 'If you do nothing, this email goes' + (data.dueAt ? ' on ' + data.dueAt : ' when it is due') + '.'
}
